module.exports = __webpack_public_path__ + "img/2012-08-18 10.54.18.01539d48.jpg";